const setGlobalData = data => {
  if (!window.globalData) {
    window.globalData = {};
  }
  window.globalData = {...window.globalData, ...data};
}

const getGlobalData = key => {
  if (!window.globalData) {
    window.globalData = {};
  }
  if (!window.globalData[key]) {
    var data = {};
    if (key==='token') {
      data = localStorage.getItem('token');
      setGlobalData({token:data});
      return data;
    }
    if (key==='info') {
      try {
        data = JSON.parse(localStorage.getItem('info'));
        setGlobalData({info:data});
        return data;
      }
      catch (e) {
        return {};
      }
    }
    return {}
  }
  return window.globalData[key];
}

// server-info aus dem header "Touren-Server" (api-version, db, host) ins info uebernehmen, nur bei aenderung
const updateServerInfo = headers => {
  const header = headers && headers.get('Touren-Server');
  if (!header) {
    return;
  }
  var server = {};
  try {
    server = JSON.parse(header);
  }
  catch (e) {
    return;
  }
  const info = getGlobalData('info');
  if (!info || (info.apiversion===server.api && info.dbname===server.db && info.host===server.host)) {
    return;
  }
  const newInfo = {...info, apiversion:server.api, dbname:server.db, host:server.host};
  setGlobalData({info:newInfo});
  localStorage.setItem('info', JSON.stringify(newInfo));
  window.dispatchEvent(new Event('serverinfo'));
}

const getInfoValue = key => {
  const info = getGlobalData('info');
  if(!info[key]) {
    return false;
  }
  return info[key];
}

const getRoute = () => {
  var r = window.location.hash;
  while (r[0]==='#' || r[0]==='/') {
    r = r.substr(1)
  }
  return r;
}

const isSuper = () => {
  return getInfoValue('isSuper');
}

const isAdmin = () => {
  return getInfoValue('isAdmin');
}

const textileConvert = (text) => {
  var t = window.textile(text);
  t = t.replace(/<a href=/g, '<a target="_blank" href=');
  return t;
};

const splitText = (s) => {
  var titel = '';
  var text = '';
  if (!s) {
    return {titel, text};
  }
  var h1 = s.indexOf('h1. ');
  if (0 <= h1) {
    var nl = s.indexOf("\n", h1);
    if (0 <= nl) {
      titel = s.substr(h1+4, nl-h1-4);
      text = s.substr(nl+1);
    }
    else {
      titel = s.substr(h1+4);
    }
  }
  else {
    text = s;
  }
  
  return {titel, text};
};

export { setGlobalData, getGlobalData, updateServerInfo, getInfoValue, getRoute, isSuper, isAdmin, textileConvert, splitText };
